import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import EditableContentMultilang from './EditableContentMultilang';
import { useTranslation } from 'react-i18next';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebaseConfig';
import { useAuth } from '../AuthContext';
import AdminLogoutButton from './AdminLogoutButton';
import './Footer.css';

const Footer = () => {
    const { t, i18n } = useTranslation();
    const { currentUser } = useAuth();
    const [footerLinks, setFooterLinks] = useState([]);

    useEffect(() => {
        const settingsDocRef = doc(db, 'site_settings', 'global');
        const unsubscribe = onSnapshot(settingsDocRef, (docSnap) => {
            if (docSnap.exists()) {
                const data = docSnap.data();
                const internalLinks = (data.navbarLinks || [])
                    .filter(link => link.enabled && link.showInFooter !== false) // <-- CORREZIONE QUI
                    .sort((a, b) => a.order - b.order);
                setFooterLinks(internalLinks);
            }
        }, (error) => {
            console.error("Errore nel caricamento dei link per il footer:", error);
        });

        return () => unsubscribe();
    }, []);

    const getTranslatedLabel = (link) => {
        const translationKeyMap = {
            home: 'navHome',
            camere: 'navRooms',
            servizi: 'navServices',
            esperienze: 'navExperiences',
            galleria: 'navGallery',
            posizione: 'navLocation',
            contatti: 'navContact',
            'configuratore': 'navConfigurator',
            'privacy-policy': 'navPrivacyPolicy',
            'termini-e-condizioni': 'navTermsConditions'
        };
        const translationKey = translationKeyMap[link.id];
        
        if (link.translations && link.translations[i18n.language] && link.translations[i18n.language].trim() !== '') {
            return link.translations[i18n.language];
        }
        return translationKey ? t(translationKey) : link.label;
    };

    return (
        <footer className="main-footer">
            <div className="footer-container container">
                <div className="footer-column brand-column">
                    <h4 className="footer-title">L'antico Piol De Feltre</h4>
                    <EditableContentMultilang
                        docPath="footer/info"
                        field="description"
                        elementType="p"
                    />
                </div>
                <div className="footer-column links-column">
                    <h4 className="footer-title">{t('footerUsefulLinks')}</h4>
                    <ul className="footer-links">
                        {footerLinks.map(link => (
                            <li key={link.id}>
                                {link.type === 'external_link' ? (
                                    <a href={link.path} target="_blank" rel="noopener noreferrer">{getTranslatedLabel(link)}</a>
                                ) : (
                                    <Link to={link.path}>{getTranslatedLabel(link)}</Link>
                                )}
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="footer-column contact-column">
                    <h4 className="footer-title">{t('footerContacts')}</h4>
                    <EditableContentMultilang docPath="footer/info" field="address" elementType="p" />
                    <EditableContentMultilang docPath="footer/info" field="phone" elementType="p" />
                    <EditableContentMultilang docPath="footer/info" field="email" elementType="p" />
                </div>
            </div>
            <div className="footer-bottom">
                <div className="container">
                    <div className="footer-bottom-content">
                        <EditableContentMultilang docPath="footer/info" field="copyright" elementType="p" />
                        {t('footerYear')}: {new Date().getFullYear()} | Crediti: Martino Garbin
                    </div>
                    {currentUser && (
                        <div className="footer-admin-section">
                            <Link to="/admin-impostazioni-sito" className="footer-admin-settings-btn" title="Impostazioni Sito">
                                ⚙️ Impostazioni
                            </Link>
                            <AdminLogoutButton />
                        </div>
                    )}
                </div>
            </div>
        </footer>
    );
}

export default Footer;